"use client";

import React from "react";
import { useModalDispatch } from "@/context/ModalContext";

import styles from "./ScholarshipJourney.module.scss";
import { IModalActions, ModalTypes } from "@/types/modal";
import { aonsatAssociatedPrograms } from "../Forms/ConnectModalFormIONSAT/utils";
import { pushToDataLayer } from "@/helpers/gtag";
import { getGlobalStateValue, IS_AONSAT_ENABLED, updateStateSession } from "@/context/utils";

const ScholarshipJourney: React.FC = () => {
  const modalDispatch = useModalDispatch();

  const onClickHanlder = () => {
    modalDispatch({
      type: IModalActions.OpenModal,
      data: {
        modalType: ModalTypes.ConnectModalAONSAT,
        modalData: {
          heading: "Register for Amity Online NSAT 2026",
          associatedPrograms: aonsatAssociatedPrograms,
          submitBtnText: "START TEST",
          rfiCase: "REDIRECT_TO_APPLICATION_JOURNEY",
        },
      },
    });


    setTimeout(() => {
      pushToDataLayer({
        event: "lead_initiate",
        cta_text: "Register AONSAT",
        section_name: getGlobalStateValue("parentSection") || "NA",
        page_type: getGlobalStateValue("pageType"),
        page_url: window?.location?.href || "NA",
      });

      updateStateSession({
        parentSection: "Middle Banner",
        leadStartingCta: "Register AONSAT",
      });

      window?.webengage?.track("register for AONSAT Clicked", {
        "Page Type": getGlobalStateValue("pageType"),
        "Section Name": "Middle Banner",
      });
    }, 2000);
  };

  return (
    <section className={styles.section}>
      <div className={styles.inner}>
        <div className={styles.textGroup}>
          <h2 className={styles.title}>
            Your Scholarship Journey <br/><span className={styles.titleHighlight}>Starts Here</span>
          </h2>
          <p className={`${styles.subtitle} lining-nums`}>
            Don't miss your chance to secure up to 100% scholarship. register now - its free
          </p>
        </div>
        {IS_AONSAT_ENABLED && <button onClick={onClickHanlder} className={styles.btn}>
          Register for Amity Online NSAT Today
        </button>}
      </div>
    </section>
  );
};
export default ScholarshipJourney;
